import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { MainTitle, CollapseBlock, Spinner } from '../../../common/index.jsx';
import IngProjectsTable from '../../../common/IngProjects/IngProjectsTable.jsx';
import { useGetPublicIngProjectsQuery } from '../../../../redux/services/ing_projects.jsx';
import { routes } from '../../../../utils/helpers/ApiClient.jsx';
import { Alert } from 'antd';

const IngProjectsPublicPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: projects, isLoading } = useGetPublicIngProjectsQuery();

  useEffect(() => {
    document.title = t('Projekty inž. štúdia') + ' | FRI UNIZA';
  }, [t]);

  const handleDetailClick = (project) => {
    navigate(routes.ingProjectsPublicDetail(project.id));
  };

  return (
    <>
      <MainTitle title={t('Projekty inž. štúdia')} />

      <div style={{ marginBottom: 12 }}>
        <Alert
          type="info"
          showIcon
          description={
            <span>
              {t(
                'Na vypísanie projektu (učitelia) alebo prihlásenie na projekt (študenti) je potrebné ',
              )}
              <a href={routes.cmsIngProjects}>{t('prejsť do portálu FRI')}</a>.
            </span>
          }
        />
      </div>

      <CollapseBlock title={t('Zoznam projektov inž. štúdia')}>
        {isLoading ? (
          <Spinner />
        ) : (
          <IngProjectsTable
            projects={projects || []}
            hideStatusColumn={true}
            onDetailClick={handleDetailClick}
            onRowClick={handleDetailClick}
            optionsWidth={128}
          />
        )}
      </CollapseBlock>
    </>
  );
};

export default IngProjectsPublicPage;
